import { render, staticRenderFns } from "./DeviceSelector.vue?vue&type=template&id=23564503&scoped=true&"
import script from "./DeviceSelector.vue?vue&type=script&lang=js&"
export * from "./DeviceSelector.vue?vue&type=script&lang=js&"
import style0 from "./DeviceSelector.vue?vue&type=style&index=0&id=23564503&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23564503",
  null
  
)

export default component.exports